module.exports = __webpack_public_path__ + "media/images/front/pc/dummy/banner300x600-a990f7ce0d000207492d5a7d7eb54f39.png";